
import React from 'react';
import { Input } from "@/components/ui/input";

interface RoomAreaInputsProps {
  roomAreas: string[];
  onRoomAreaChange: (index: number, value: string) => void;
}

const RoomAreaInputs: React.FC<RoomAreaInputsProps> = ({ 
  roomAreas, 
  onRoomAreaChange 
}) => {
  if (roomAreas.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <h3 className="font-medium text-gray-700">Powierzchnia pokoi (w m²)</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {roomAreas.map((area, index) => (
          <div key={index} className="space-y-1">
            <label className="text-sm text-gray-600">
              Pokój {index + 1}
            </label>
            <Input
              type="text"
              value={area}
              onChange={(e) => onRoomAreaChange(index, e.target.value)}
              placeholder={`Np. 15.5`}
              className="input-field"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoomAreaInputs;
